import { render, staticRenderFns } from "./DragDropFileInput.vue?vue&type=template&id=4d8a6fbf&scoped=true&"
import script from "./DragDropFileInput.vue?vue&type=script&lang=ts&"
export * from "./DragDropFileInput.vue?vue&type=script&lang=ts&"
import style0 from "./DragDropFileInput.vue?vue&type=style&index=0&id=4d8a6fbf&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8a6fbf",
  null
  
)

export default component.exports